import { apiClient } from './api'

/** Vendor-neutral shape — backend deliberately omits provider/model id from
 * the response so the UI can never accidentally surface them to customers.
 * See backend/app/api/v1/endpoints/ai_health.py for the contract. */
export type AIHealthErrorCode =
  | 'not_configured'
  | 'auth_failed'
  | 'rate_limited'
  | 'timeout'
  | 'upstream_error'
  | 'unknown'

export interface AIHealth {
  configured: boolean
  reachable: boolean
  error_code: AIHealthErrorCode | null
  checked_at: number
}

export const aiHealthService = {
  get: async (refresh = false): Promise<AIHealth> => {
    const { data } = await apiClient.get<AIHealth>('/api/v1/ai/health', {
      params: refresh ? { refresh: true } : undefined,
    })
    return data
  },
}
